/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import {accounting} from 'accounting'
import {productShop} from '../../lib/path'

class ProductReportComponent extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {}

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let {products, aggregation, personId, planDateMin, planDateMax, dayPartId, productFrom} = this.props

    return (
      <table className="baseTable">
        <tbody>
          <tr className="firstRow">
            <td>ردیف</td>
            <td>نام تامین کننده</td>
            <td>کد محصول</td>
            <td>نام محصول</td>
            <td>تعداد</td>
            <td>مقدار</td>
            <td>واحد شمارش</td>
            <td>تعداد پارت تحویل</td>
            <td className="priceCell">قیمت کل</td>
            <td className="priceCell">تخفیف</td>
            <td className="priceCell">قابل پرداخت</td>
            <td>فاکتورهای این کالا</td>
          </tr>
          {products.map((product, index) => (
            <tr key={index}>
              <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
              <td>{product.providerName}</td>
              <td>{product.productCode}</td>
              <td>
                <a target="_blank" href={productShop({articleId: product.articleId})}>
                  {product.productName}
                </a>
              </td>
              <td>{product.productQuantityCount == '0' ? '-' : product.productQuantityCount}</td>
              <td>{product.productQuantityValue}</td>
              <td>{product.productUnitTitle}</td>
              <td>{product.deliveryCount}</td>
              <td className="priceCell">{accounting.formatMoney(product.totalAmount, '', ',')}</td>
              <td className="priceCell">
                {accounting.formatMoney(Number(product.discountAmount) + Number(product.extraDiscountAmount), '', ',')}
              </td>
              <td className="priceCell">{accounting.formatMoney(product.payableAmount, '', ',')}</td>
              {productFrom === 'driver' ? (
                <td>
                  <Link
                    to={`/FactorProductDriver/${personId}/${planDateMin}/${planDateMax}/${product.productId}/${
                      product.providerName
                    }/${product.productName.replace(/\//g, '')}/${dayPartId}`}
                    target="_blank"
                  >
                    <img src={require('../../image/editDriver.svg')} alt="" />
                  </Link>
                </td>
              ) : productFrom === 'dispatch' ? (
                <td>
                  <Link
                    to={`/FactorProductDispatch/${product.productId}/${product.providerName}/${product.productName}/${
                      this.props.name
                    }/${this.props.planDate}`}
                    target="_blank"
                  >
                    <img src={require('../../image/editDriver.svg')} alt="" />
                  </Link>
                </td>
              ) : productFrom === 'plan' ? (
                <td>
                  <Link
                    to={`/FactorProductPlan/${product.productId}/${product.providerName}/${product.productName}/${
                      this.props.planDate
                    }`}
                    target="_blank"
                  >
                    <img src={require('../../image/editDriver.svg')} alt="" />
                  </Link>
                </td>
              ) : (
                ''
              )}
            </tr>
          ))}
          <tr>
            <td colSpan={4}>مجموع</td>
            <td colSpan={1}>{aggregation.productQuantityCount}</td>

            <td colSpan={1}>{aggregation.productQuantityValue}</td>
            <td />
            <td colSpan={1}>{aggregation.deliveryCount}</td>
            <td className="priceCell" colSpan={1}>
              {accounting.formatMoney(aggregation.totalAmount, '', ',')}
            </td>
            <td className="priceCell" colSpan={1}>
              {accounting.formatMoney(aggregation.discountAmount + aggregation.extraDiscountAmount, '', '')}
            </td>
            <td className="priceCell" colSpan={1}>
              {accounting.formatMoney(aggregation.payableAmount, '', ',')}
            </td>
            <td />
          </tr>
        </tbody>
      </table>
    )
  }
}

export default ProductReportComponent
